import React from "react";
import {connect} from 'react-redux'

import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import {
  symbolGroupSave,
  symbolGroupsFetch,
  symbolGroupFetch
} from 'actions/symbolGroups'
import {
  symbolFilter,
  symbolsFetch,
  symbolSave
} from 'actions/symbols'
import {
  danger,
  success,
} from 'actions/notification'

//styles
import styles from "assets/jss/material-dashboard-pro-react/views/form";

class Form extends React.Component {
  state={
    form:{
      symbolGroupId:0,
      symbols: [],
      name:'',
    },
    oldSymbols: []
  }
  componentDidMount(){
    this.props.symbolFilter({size: 100000})

    //Fetch information if is edit form
    if(this.props.match.params.id){
      
      this.props.fetch(this.props.match.params.id)
        .then(e => {
          this.props.symbolsFetch().then((s) => {
            const symbols = s.content.filter((symb) => {
              return symb.groupId === e.symbolGroupId
            })
            this.setState({
              ...this.state,
              form:{
                ...e,
                symbols: symbols.map((i) => i.symbolId)
              },
              oldSymbols: symbols
            })
          })
        });
    }
  }
  //Submit form
  submit(e){
    if(e.preventDefault)
      e.preventDefault();
    const dataGroup = this.state.form
    const oldSymbols = this.state.oldSymbols

    this.props.save(dataGroup)
      .then(e=>{
        dataGroup.symbols.forEach((symbolId) => {
          let symbolObj = this.props.symbols.find((x) => x.symbolId === symbolId)
          symbolObj.groupId = e.symbolGroupId
          symbolObj.baseCurrencyId = symbolObj.baseCurrency.currencyId
          symbolObj.quoteCurrencyId = symbolObj.quoteCurrency.currencyId
          
          this.props.symbolSave(symbolObj)
        })

        oldSymbols.forEach((symbolObj) => {
          let symbol = dataGroup.symbols.find((x) => x === symbolObj.symbolId)
          if(symbol) return;
          symbolObj.groupId = null
          symbolObj.baseCurrencyId = symbolObj.baseCurrency.currencyId
          symbolObj.quoteCurrencyId = symbolObj.quoteCurrency.currencyId
          this.props.symbolSave(symbolObj)
        })
        
        this.props.success(e.name+ ' '+(this.state.form.symbolGroupId?'Edited':'Added')+'!',4); 
        this.props.fetchAll()
        this.props.history.goBack()
      })
      .catch(e=>{this.props.danger(e+'',4);})
  }
  //OnChange action for all inputs and selects
  change(event,name){
    this.setState({
      ...this.state,
      form:{
        ...this.state.form,
        [name]:event.target.value
      },
    })
  }

  getInput(data){
    return   <CustomInput
        labelText={
          <span>
            {data.name} {(data.required?<small>(required)</small>:data.required)}
          </span>
        }
        id={data.key}
        formControlProps={{
          fullWidth: true
        }}
        inputProps={{
          onChange: event => this.change(event, data.key),
          required:data.required,
          value:this.state.form[data.key],
          type:data.type,
          endAdornment: (
            <InputAdornment
              position="end"
              className={this.props.classes.inputAdornment}
            >
              {data.icon}
            </InputAdornment>
          )
        }}
    />
  }
  render() {
    const {classes,isFetching}=this.props;
    return (
          <GridContainer justify="center">
            <GridItem xs={12} sm={8}>
            <Card>
            <CardBody>
          
            {//Show progress onFetch
            (isFetching)         
            ?<LinearProgress/>
            :<form
              onSubmit={this.submit.bind(this)}
            >
              <GridContainer justify="center">
                {/*Header Information*/}
                <GridItem xs={12} sm={12}>
                  <h4 className={classes.infoText}>
                    Complete information
                  </h4>
                </GridItem>
                {/*Right 2 inputs*/}
                <GridItem xs={12} sm={12} md={12} lg={10}>
                  {/*Name input*/}
                  {this.getInput({
                      key:'name',
                      name:'Name',
                      icon:<RecordVoiceOverIcon className={this.props.classes.inputAdornmentIcon}/>,
                      type:'text',
                      required:true
                      })}
                </GridItem>

                <GridItem xs={12} sm={12} md={12} lg={10}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Symbols
                      </InputLabel>
                      <Select
                        multiple
                        value={this.state.form.symbols}
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        inputProps={{
                          onChange:event => this.change(event, 'symbols'),
                          id: "multiple-select"
                        }}>
                          {Object.values(this.props.symbols).map(item => 
                            <MenuItem key={item.symbolId} value={item.symbolId}>{item.name}</MenuItem>
                          )}
                      </Select>
                    </FormControl>
                  </GridItem>
                  
                <GridItem xs={12} sm={12} md={12} lg={10}>
                  <Button type="submit"  className={classes.submit} color="success">Submit</Button>
                </GridItem>
              </GridContainer>
              </form>
            }
              </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
    );
  }
}
const mapStateToProps=(state,props)=>({
  isFetching: state.symbolGroups.isFetching,
  symbolGroups: state.symbolGroups.list,
  symbols: state.symbols.list
})
const mapDispatchToProps=(dispatch)=>({
  fetch:(id)=>dispatch(symbolGroupFetch(id)),
  fetchAll:()=>dispatch(symbolGroupsFetch()),
  save:(data)=>dispatch(symbolGroupSave(data)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  success:(text,sec)=>dispatch(success(text,sec)),
  symbolSave: (data) => dispatch(symbolSave(data)),
  symbolFilter: (filter) => dispatch(symbolFilter(filter)),
  symbolsFetch: () => dispatch(symbolsFetch())
})
export default withStyles(styles)(connect(mapStateToProps,mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/views/SymbolGroups/Form.jsx